import "./BusinessDatePickerComponent.scss";
import {IComponentOptions, IOnInit, ui} from "angular";
import {IDatepickerConfig} from "angular-ui-bootstrap";
import {disableWeekends} from "../date-picker/DatePickerDefaults";
import {areSameDate} from "../../js/util/DateTimeUtil";
import {ComponentCallback} from "../../types/AngularJS";

export const BusinessDatePicker = "tfBusinessDatePicker";

export function businessDatePicker(): IComponentOptions {
    return {
        templateUrl: "app/components/business-date-picker/BusinessDatePickerComponent.html",
        bindings: {
            date: "<",
            holidays: "<",
            expiries: "<",
            minDate: "<",
            maxDate: "<",
            attachToBody: "<",
            required: "<",
            disabled: "<",
            onChange: "&",
        },
        controllerAs: "ctrl",
        controller: BusinessDatePickerComponentController
    };
}

export class BusinessDatePickerComponentController implements IOnInit {

    public date: string;
    public holidays: Array<Date> | null;
    public expiries: Array<Date> | null;
    public maxDate: Date | null;
    public minDate: Date | null;
    public attachToBody?: boolean;
    public required: boolean | null;
    public disabled: boolean | null;
    public onChange: ComponentCallback;

    public options: IDatepickerConfig;

    public $onInit() {
        this.options = {
            datepickerMode: "day",
            dateDisabled: this.isDayDisabled.bind(this),
            customClass: this.styleExpiryDays.bind(this)
        };
    }

    private styleExpiryDays({date}: ui.bootstrap.IDatepickerCellArgs): string {
        const isExpiry = this.expiries != null && this.expiries.some(d => areSameDate(d, date));
        return isExpiry ? "expiry-date" : "";
    }

    private isDayDisabled(data: ui.bootstrap.IDatepickerCellArgs): boolean {
        return disableWeekends(data) || this.disableHolidays(data);
    }

    private disableHolidays({date, mode}: ui.bootstrap.IDatepickerCellArgs): boolean {
        if (mode !== "day") {
            return false;
        }
        return this.holidays != null && this.holidays.some(d => areSameDate(d, date));
    }
}
